import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import SectionHeader from '@/components/feature/SectionHeader';

const GALLERY = [
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616629_2_500-375.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616584_1_250-250.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616569_0_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616579_0_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616594_2_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616599_0_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616604_0_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616614_0_250-187.jpg', label: 'S+N Metall' },
  { src: 'https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616564_0_250-141.jpg', label: 'S+N Metall' },
];

export default function GallerySection() {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState<string | null>(null);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setActiveImage(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeader
          eyebrow={t('processing.gallery.eyebrow')}
          title={t('processing.gallery.title')}
          subtitle={t('processing.gallery.subtitle')}
        />

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {GALLERY.map((image, index) => (
            <Reveal key={image.src} delay={(index % 3) * 90}>
              <button
                type="button"
                onClick={() => setActiveImage(image.src)}
                className="group block w-full overflow-hidden rounded-lg border border-background-200"
              >
                <div className="h-60 w-full overflow-hidden">
                  <img
                    src={image.src}
                    alt="Arbeitsprobe aus der Blechbearbeitung von S+N Metall"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {activeImage && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/90 p-4 animate-fade-in"
          onClick={() => setActiveImage(null)}
          role="presentation"
        >
          <button
            type="button"
            aria-label="Close"
            className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-background-50/10 text-2xl text-background-50 transition-colors duration-200 hover:bg-background-50/20"
            onClick={() => setActiveImage(null)}
          >
            <i className="ri-close-line" />
          </button>
          <div className="max-h-[85vh] max-w-4xl overflow-hidden rounded-lg" onClick={(e) => e.stopPropagation()} role="presentation">
            <img src={activeImage} alt="Arbeitsprobe aus der Blechbearbeitung von S+N Metall" className="max-h-[85vh] w-auto object-contain" />
          </div>
        </div>
      )}
    </section>
  );
}